import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Resources from '../resourceLinks/ResourceLinks';
import AudioControls from "../audio/SimpleAudioController";
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as componentConstants from '../../../constants/componentConstants';
import * as animationHelper from "../../../helpers/animationHelper";

class DialogPrompt extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            screenObject: props.screenObject,
            lang: this.props.lang,
            locale: appHelper.getLocalData(props.screenObject),
            isVisible: false,
            screen: appHelper.getScreenByAssetId(props.screenObject.asset_id),
            character: {
                src: "",
                pose: "",
                position: ""
            },
            resourceLinks: [],
            hasResources: false,
            audio: {
                src: "",
            },
            allowAudioAutoPlay: appHelper.isDefined(props.allowAudioAutoPlay) ? props.allowAudioAutoPlay : true,
            showLabels: false,
            showAnimation: false,
        };

        this.show = this.show.bind(this);
        this.onShowComplete = this.onShowComplete.bind(this);
        this.hide = this.hide.bind(this);
        this.onHideComplete = this.onHideComplete.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getClass = this.getClass.bind(this);
        this.setResources = this.setResources.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);

        //Create Refs
        this.speachBubble = React.createRef();
    }

    componentDidMount() {
        this.setResources();
        this.getAssets();
        if((appHelper.isDefined(this.props.animatePrompt) && this.props.animatePrompt) || !appHelper.isDefined(this.props.animatePrompt)) {
            this.show();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: Object.assign({}, nextProps.lang),
                locale: appHelper.getLocalData(this.state.screenObject),
            });
        }
    }

    componentDidUpdate() {
    }

    getAssets() {
        let screenCharacter = {};
        let characterAsset = Object.assign(this.state.character);

        if (appHelper.isDefined(this.state.screen.assets.character)) {
            screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.character);
            characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.character);
        }

        if (appHelper.isDefined(this.state.screenObject.asset_id)) {
            let asset = appHelper.getArrayObjectByKey(this.state.screen.objects, "asset_id", this.state.screenObject.asset_id);
            if (appHelper.isDefined(asset.character_pose) && asset.character_pose.pose !== objectConstants.INHERIT) {
                characterAsset = appHelper.getCharacterPose(screenCharacter, asset.character_pose);
            }

        }
        if (appHelper.isDefined(this.state.screenObject.audio) && appHelper.isDefined(this.state.locale.audio)) {
            let audio = appHelper.getAudioAsset(this.state.locale.audio);
            if (appHelper.isDefined(this.state.screenObject.audio.enabled) && this.state.screenObject.audio.enabled) {
                if (this.state.screenObject.asset_type_code === componentConstants.AUDIO_CHOICE || (appHelper.isDefined(this.state.screenObject.audio.show_audio_controls) && this.state.screenObject.audio.show_audio_controls)) {
                    this.setState({
                        audio: Object.assign({}, audio),
                    });
                } else {
                    let audioObj = {
                        audioRef: `audio_${audio.id}_${audio.type}`,
                    };
                    if (this.state.allowAudioAutoPlay && appHelper.isDefined(this.state.screenObject.audio.auto_play) && this.state.screenObject.audio.auto_play) {
                        this.props.actions.setAudio(audioObj);
                    }
                }
            }
        }


        if (appHelper.isDefined(characterAsset.src)) {
            this.setState({character: Object.assign({}, characterAsset)});
        }

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    show() {
        let params = {
            ele: prompt,
            duration: objectConstants.SPEECH_BUBBLE_DURATION,
            delay: 0,
            callback: this.onShowComplete
        };
        animationHelper.showHeight(params);
    }


    onShowComplete() {
        this.setState({isVisible: true});
        if (appHelper.isDefined(this.props.onComplete)) {
            this.props.onComplete();
        }

    }

    hide() {
        let prompt = this.speachBubble.current;
        let params = {
            ele: prompt,
            duration: objectConstants.SPEECH_BUBBLE_DURATION,
            delay: 0,
            callback: this.onHideComplete
        };
        animationHelper.hideHeight(params);
    }

    onHideComplete() {
        this.setState({isVisible: false});
    }

    getClass() {
        return appHelper.isDefined(this.state.character.src) && this.state.character.src.length > 0 ? 'customer-has-expression' : '';
    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.state.screenObject.prompt_settings);
        let hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);

        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
        });

    }

    onResourcesComplete() {

    }


    render() {
        return (
            <div className={(appHelper.isDefined(this.props.animatePrompt) && this.props.animatePrompt) || !appHelper.isDefined(this.props.animatePrompt) ? "a-c" : ""} ref={this.speachBubble}>
                <div className={`  object-container-conversation ${this.getClass()}`}
                     ref={`prompt_${this.state.screenObject.asset_id}`}>
                    {
                        this.state.screenObject.show_title
                            ? <h4 className={this.state.screenObject.prompt_settings.title_style}
                                  dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                            : null
                    }
                    <div className="customer_name_label">
                        {appHelper.isDefined(this.props.character_name) && this.props.character_name !== null && this.props.character_name.length > 0
                            ?
                            <span>{this.props.character_name}</span>
                            :
                            <span>Character</span>
                        }
                    </div>
                    {appHelper.isDefined(this.state.character.src) && this.state.character.src.length > 0
                        ?
                        <div className="character-expression">
                            <img src={this.getImagePath(this.state.character.src)} alt=""/>
                        </div>
                        :
                        null
                    }

                    {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description !== null && this.state.locale.description.length > 0
                        ?
                        appHelper.isDefined(this.state.screenObject.audio) && (this.state.screenObject.asset_type_code === componentConstants.AUDIO_CHOICE || (appHelper.isDefined(this.state.screenObject.audio.show_audio_controls) && this.state.screenObject.audio.show_audio_controls)) && appHelper.isDefined(this.state.audio.id)
                            ?
                            <div
                                className={`character speak ${this.props.contentData.experience.speech_bubble_corner_style !== null ? this.props.contentData.experience.speech_bubble_corner_style : 'round'}`}>
                                <div className="dialog-content">

                                    <AudioControls audio={this.state.audio}
                                                   autoPlay={this.state.screenObject.audio.auto_play && this.state.allowAudioAutoPlay}
                                                   showLabels={this.state.showLabels}
                                                   themeType="light"
                                                   showAnimation={this.state.showAnimation}
                                                   audioRef={`text_audio_${this.state.screenObject.asset_id}_${this.state.audio.id}_${this.state.audio.constant}`}/>


                                    <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                </div>
                            </div>
                            :
                            <div
                                className={`character speak ${this.props.contentData.experience.speech_bubble_corner_style !== null ? this.props.contentData.experience.speech_bubble_corner_style : 'round'}`}
                                dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                        : null
                    }
                    {
                        this.state.hasResources
                            ?
                            <div style={{marginLeft: "36px", marginTop: "10px"}}>

                                <Resources resources={this.state.resourceLinks}
                                           onResourcesComplete={this.onResourcesComplete}/>
                            </div>

                            :
                            null
                    }
                </div>
            </div>

        );
    }
}

DialogPrompt.propTypes = {
    character_name: PropTypes.string,
    screenObject: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    onComplete: PropTypes.func,
    allowAudioAutoPlay: PropTypes.bool,
    animatePrompt: PropTypes.bool,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

DialogPrompt.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DialogPrompt);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/DialogPrompt.js
 **/